import script from "./UpdateSpecialApprovalPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateSpecialApprovalPage.vue?vue&type=script&setup=true&lang=js"

import "./UpdateSpecialApprovalPage.vue?vue&type=style&index=0&id=f7f151a2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7f151a2"]])

export default __exports__